import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EnterOrderComponent } from 'src/app/shared/components/enter-order/enter-order.component';
import { DialogTypeEnum } from 'src/app/dashboard/interfaces/DialogType';
import { Router } from '@angular/router';
import { DrugsProcessingService } from '../drugs-processing.service';
import { Select, Store } from '@ngxs/store';
import { InventoryState } from 'src/app/shared/states/inventory/inventory.state';
import { BulkGetSimilarOnHandInventory, GetInventoryForDrug } from 'src/app/shared/states/inventory/inventory.actions';
import { Observable, combineLatest } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';
import { ActivityTypesEnum } from 'src/app/shared/interfaces/ActivityTypesEnum';
import { highlightRequiredControlsWithErrors } from 'src/app/shared/helpers/helpers';
import { UntypedFormGroup } from '@angular/forms';
@UntilDestroy()
@Component({
  selector: 'app-receive-dialog',
  templateUrl: './receive-dialog.component.html',
  styleUrls: ['./receive-dialog.component.scss', './../user-board-dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReceiveDialogComponent implements OnInit {

  @Input() dialogType: DialogTypeEnum = DialogTypeEnum.Receive;
  @Input() selectedDrug = undefined;
  @Input() maxValueExceededErrorMessage: string;
  @Input() excludedLocations: string[];
  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  
  orderDetailsForm: UntypedFormGroup;

  @ViewChild('enterOrderComponent') enterOrderComponent: EnterOrderComponent;

  @Select(InventoryState.loading) loading$: Observable<boolean>;

  DialogTypeEnum = DialogTypeEnum;
  ActivityTypesEnum = ActivityTypesEnum;

  constructor(private router: Router, private drugsService: DrugsProcessingService, private store: Store, private cdr: ChangeDetectorRef) {
  }
  ngOnInit(): void {
    this.drugsService.searchScannerDrugSelected$
    .pipe(untilDestroyed(this), withLatestFrom(this.loading$))
    .subscribe(([option, loading]) => {
      if(!loading && option && option.id && option?.onHand === undefined) {
        this.store.dispatch(new GetInventoryForDrug(option.id, this.store.selectSnapshot(InventoryState.primaryLocationID)))
          .pipe(untilDestroyed(this))
          .subscribe(() => {
            const inventory = this.store.selectSnapshot(InventoryState)?.receiveSelectedDrugInventory;
            if (inventory) {
              const copy = {...this.store.selectSnapshot(InventoryState)?.receiveSelectedDrugInventory};
              copy.gpi = option.gpi;
              this.drugsService.searchScannerDrugSelected$.next(copy)
            } else if (option.gpi) { //try to find soh 
              this.store.dispatch(new BulkGetSimilarOnHandInventory([option.gpi]))
              .pipe(untilDestroyed(this))
              .subscribe(() => {
                const operationResult = this.store.selectSnapshot(InventoryState.similarOnHand);
                this.drugsService.searchScannerDrugSelected$.next({...option, onHand: 0, similarOnHand: operationResult?.[0]?.soh });
              })
            } else {
              this.drugsService.searchScannerDrugSelected$.next({...option, onHand: 0});
            }
          });
      }
    });
  }

  receiveDrug(formValue: any): void {
    const form = this.enterOrderComponent.getForm();    
    if (form?.invalid) {
      this.validateOrderForm(form);
    } else {
      this.save.emit({...formValue, ...form?.getRawValue()});
      this.enterOrderComponent.getForm()?.reset();
    }
  }

  validateOrderForm(form?: UntypedFormGroup): void {
    form??= this.enterOrderComponent.getForm();
    highlightRequiredControlsWithErrors(form);
    this.enterOrderComponent?.orderFormComponent?.markForCheck();
    this.enterOrderComponent?.orderFormComponent?.supplierBuyerDetails?.highlightRequiredControlsWithErrors();
  }


  navigateToBulkAdd() {
     this.router.navigateByUrl('inventory/bulk-add');
  }
}
